<template>
    <div>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <!-- <v-container> -->


        <div class="guides py-3 px-6">
            <div>
                <div class="text-h5 mb-5 black--text ">
                    <strong>Guia de Uso da loja</strong>
                </div>
                <v-tabs v-model="page" vertical background-color="transparent">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab v-if="!loading" @click="current = null">
                        <div class="text-left" style="width: 100%; white-space: normal;">
                            Início
                        </div>
                    </v-tab>
                    <template v-for="item in items">
                        <h4 class="pb-2" :key="`${item.category}-title`">
                            {{ item.category }}
                        </h4>

                        <v-tab class="text-left" @click="openGuide(item)" v-for="(item, i) in item.items"
                            :key="`${item.category}-${i}`" left>

                            <div class="text-left" style="width: 100%; white-space: normal;">
                                {{ item.title }}
                            </div>
                        </v-tab>
                    </template>
                </v-tabs>

            </div>
            <!-- <v-card class="mx-auto" max-width="300" tile>
                
                <v-list dense v-if="!loading">
                    <template v-for="item in items">
                        <v-subheader :key="`${item.category}-title`">{{ item.category }}</v-subheader>
                        <v-list-item-group :key="`${item.category}-list`" color="primary">
                            <v-list-item @click="current = item" v-for="(item, i) in item.items" :key="i">

                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </template>
                </v-list>
            </v-card> -->
            <div>
                <v-card elevation="0">
                    <template v-if="current">
                        <v-card-title>{{ current.title }}</v-card-title>
                        <v-card-text class="py-0">
                            <v-card tile>
                                <iframe class="pageH" frameBorder="0" v-if="current.document && current.document.url"
                                    :src="`${current.document.url}#toolbar=0&view=FitH`"
                                    style="background-color: #f0f0f0;" width="100%"></iframe>
                            </v-card>
                        </v-card-text>
                    </template>
                    <template v-else>
                        <h3>
                            Bem-vindos aos guias de uso da plataforma de gestão Media Vendor!
                        </h3>
                        <p>

                            Navegue pelas categorias para visualizar os manuais de boas práticas e receber todo auxílio
                            necessário para configurar e administrar sua loja, com dicas e recomendações. </p>
                    </template>
                </v-card>
            </div>

        </div>
        <!-- </v-container> -->
    </div>
</template>
<script>
export default {
    name: "GuideDocuments",
    data() {
        return {
            page: 0,
            items: {},
            documents: [],
            loading: false,
            current: null
        }
    },
    mounted() {
        this.loadDocuments()
    },
    methods: {
        openGuide(item) {
            console.log('new item', item)
            this.current = JSON.parse(JSON.stringify(item))
            this.$axios.post(`guideDocuments/log`, { guideId: item.id }).then((response) => {
                this.documents = response.data.data
                this.loading = false
            })
        },
        loadDocuments() {
            this.loading = true
            this.$axios.get(`guideDocuments?target=Media+Vendor`).then((response) => {
                this.documents = response.data.data

                const groups = {}
                this.documents.forEach((doc) => {
                    if (!groups.hasOwnProperty(doc.category)) {
                        groups[doc.category] = {
                            category: doc.category,
                            items: []
                        }
                    }
                    groups[doc.category].items.push(doc)
                })
                this.items = groups
                this.loading = false
            })
        }
    },
    computed: {


    }
}
</script>
<style>
.guides {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 4fr;

}

iframe.pageH {
    height: calc(100vh - 230px);
}
</style>